import { PortableText as BasePortableText } from "@portabletext/react";
import React from "react";
import { Link } from "gatsby";
import clientConfig from "../../client-config";
import { Button } from "./button";
import { Figure } from "./figure";
import Tooltip from "./tooltip";

const components = {
  block: {
    heading: ({ children }) => <>{children}</>,
    h2: ({ children }) => <h2 className="h4">{children}</h2>,
    h3: ({ children }) => <h3 className="h5">{children}</h3>,
  },

  types: {
    button: ({ value }) => <Button node={value} portableTextButton />,
    mainImage: ({ value }) => <Figure node={value} />,
  },

  marks: {
    link: ({ value, children }) => {
      if (value?.blank) {
        return (
          <a
            href={value?.url?.replace("www.pureweb.com", "")}
            target="_blank"
            rel="noreferrer noindex nofollow"
          >
            {children}
          </a>
        );
      }
      return (
        <Link to={value?.url?.replace("www.pureweb.com", "")}>{children}</Link>
      );
    },
    tooltip: ({ children, value }) => (
      <Tooltip asset={value.asset} tooltipContent={value.tooltip}>
        {children}
      </Tooltip>
    ),
  },
};

const PortableText = ({ blocks }) => {
  return (
    <BasePortableText
      value={blocks}
      components={components}
      {...clientConfig.sanity}
    />
  );
};

export default PortableText;
